module.exports = __webpack_public_path__ + "static/Curbix-3-44737ef95b3aa66837a992ff1e5ad098.jpg";